import { makeStyles } from '@material-ui/styles'
import PicklistField from 'core/components/validatedForm/DropdownField'
import KeyValuesField from 'core/components/validatedForm/KeyValuesField'
import TextField from 'core/components/validatedForm/TextField'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import React from 'react'
import { keyValueArrToObj, objToKeyValueArr } from 'utils/fp'
import StorageClassesPicklist from '../storage-classes/StorageClassesPicklist'
import AccessModePicklist from './AccessModePicklist'
import PvcSizePicklist from './PvcSizePicklist'
import VolumeModePicklist from './VolumeModePicklist'

const useStyles = makeStyles<Theme>((theme) => ({
  fields: {
    display: 'grid',
    gap: 24,
  },
  withUnits: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  unitsDropdown: {
    position: 'relative',
    bottom: 1,
  },
}))

export default function PvcParamFields({ params, updateParams, clusterId }) {
  const classes = useStyles()

  return (
    <div className={classes.fields} data-testid="pvc-param-fields-container">
      <TextField
        id="name"
        label="Name"
        placeholder="Enter name..."
        onChange={(value) => updateParams({ name: value })}
        required
        data-testid="pvc-name-input"
      />
      <PicklistField
        DropdownComponent={StorageClassesPicklist}
        id="storageClass"
        clusterId={clusterId}
        label="Storage Class"
        onChange={(value) => updateParams({ storageClass: value })}
        value={params?.storageClass}
        compact={false}
        data-testid="pvc-storage-class-picklist"
      />
      <PicklistField
        DropdownComponent={AccessModePicklist}
        id="accessMode"
        label="Access Mode"
        onChange={(value) => updateParams({ accessMode: value })}
        value={params?.accessMode}
        compact={false}
        data-testid="pvc-access-mode-picklist"
      />
      <PicklistField
        DropdownComponent={VolumeModePicklist}
        id="volumeMode"
        label="Volume Mode"
        onChange={(value) => updateParams({ volumeMode: value })}
        value={params?.volumeMode}
        compact={false}
        data-testid="pvc-volume-mode-picklist"
      />
      <div className={classes.withUnits} data-testid="pvc-size-with-units-container">
        <TextField
          id="size"
          label="Size"
          onChange={(value) => updateParams({ size: value })}
          value={params.size}
          type="number"
          min={1}
          data-testid="pvc-size-input"
        />
        <PvcSizePicklist
          name="Unit"
          value={params.sizeUnit}
          onChange={(value) => updateParams({ sizeUnit: value })}
          className={classes.unitsDropdown}
          data-testid="pvc-size-unit-picklist"
        />
      </div>
      <div data-testid="pvc-label-selectors-container">
        <Text variant="caption1">Use label selectors to request storage.</Text>
        <KeyValuesField
          id="labels"
          value={objToKeyValueArr(params?.labels)}
          onChange={(value) => updateParams({ labels: keyValueArrToObj(value) })}
          addLabel="Add Label Selector"
          allowMultipleValues
          data-testid="pvc-label-selectors-field"
        />
      </div>
    </div>
  )
}
